import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Icon from '../../components/icons.jsx'
import OperacaoTaskList from './OperacaoTaskList.jsx'
import CommercialPipelineList from './CommercialPipelineList.jsx'
import OperacaoEquipes from './OperacaoEquipes.jsx'
import OperationProjectTasks from './OperationProjectTasks.jsx'

const AREAS = [
  { id: 'tarefas', label: 'Tarefas', icon: 'timeline', path: '/operacao/tarefas' },
  { id: 'projetos', label: 'Projetos', icon: 'folder', path: '/operacao/projetos' },
  { id: 'equipes', label: 'Equipes', icon: 'users', path: '/operacao/equipes' },
]

export default function OperacaoOverview({ data, query, onRefresh }) {
  const { pathname, search } = useLocation()
  const navigate = useNavigate()
  const area = AREAS.find(item => item.path === pathname)?.id || 'tarefas'
  const [projectArea, setProjectArea] = useState('projects')
  const linkedProjectId = area === 'projetos' ? new URLSearchParams(search).get('projeto') : null
  const currentProjectArea = linkedProjectId ? 'projects' : projectArea
  const openProject = id => navigate(`/operacao/projetos?projeto=${encodeURIComponent(id)}`)
  const backToProjects = () => { setProjectArea('projects'); navigate('/operacao/projetos') }
  const changeProjectArea = next => { setProjectArea(next); if (linkedProjectId) navigate('/operacao/projetos') }
  return <>
    <div className="ov-navigation">
      <nav aria-label="Navegação da operação">
        {AREAS.map(({ id, label, icon, path }) =>
          <button type="button" key={id} className={area === id ? 'active' : ''} aria-pressed={area === id} onClick={() => navigate(path)}><Icon n={icon} s={17} />{label}</button>
        )}
      </nav>
      <button type="button" className="ov-text-button" onClick={onRefresh}><Icon n="refresh" s={13} /> Atualizar</button>
    </div>
    <div className="ov-detail">
      {area === 'projetos' && <nav className="oc-origin-tabs" aria-label="Listas de projetos e funis"><button type="button" aria-pressed={currentProjectArea === 'projects'} onClick={() => changeProjectArea('projects')}>Projetos</button><button type="button" aria-pressed={currentProjectArea === 'commercial'} onClick={() => changeProjectArea('commercial')}>Funis comerciais</button></nav>}
      {linkedProjectId ? <OperationProjectTasks key={`${query.clientId}:${linkedProjectId}`} projectId={linkedProjectId} data={data} query={query} onBack={backToProjects} onProjectChange={openProject} onRefresh={onRefresh} /> : area === 'equipes' ? <OperacaoEquipes data={data} query={query} onRefresh={onRefresh} /> : area === 'projetos' && currentProjectArea === 'commercial' ? <CommercialPipelineList data={data} query={query} onRefresh={onRefresh}/> : <OperacaoTaskList key={area} data={data} query={query} kind={area === 'projetos' ? 'projetos' : 'minhas'} onRefresh={onRefresh} />}
    </div>
  </>
}
